import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllAcademicRecognitionNacidStatuses } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/arNacidStatuses";
const arNacidStatusesSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(arNacidStatusesThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(arNacidStatusesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(arNacidStatusesThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const arNacidStatusesThunk = createAsyncThunk(
  `${sliceName}/arNacidStatusesThunk`,
  async () => {
    const response = await getAllAcademicRecognitionNacidStatuses()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.arNacidStatuses);
    },
  },
);

export default arNacidStatusesSlice.reducer;
